import type { FaireProductEntity } from "../../entity_types/product";

export const p_wb569xuuus: FaireProductEntity = {
  token: "p_wb569xuuus",
  type: "product",
  name: "Mini Hearts Blush Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/99470701a1120431fcd0db081325fe63b21a252d645cf924882d7c49b1421f66.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/156ddd9f3d182c8489f5eba4795dd8602e4ccf5b45c2094b427a809918abe33b.jpeg",
    "https://cdn.faire.com/fastly/f424a1c434b1e58f78843e7615b13114fead5ca4663579b00cbd7033da3db57c.jpeg",
    "https://cdn.faire.com/fastly/11b3d1788ee98e0536bba42c922a35898786d709939eb268a1d32abbd991a75f.jpeg",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a reminder that someone is seen. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:18.435Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
